import * as React from 'react';

import { IconBrandsFacebook } from '@doltech/icons/IconBrandsFacebook';
import { IconBrandsLogoYoutube1 } from '@doltech/icons/IconBrandsLogoYoutube1';
import { IconBrandsTiktok1 } from '@doltech/icons/IconBrandsTiktok1';
import { Link } from '../../../../Link';
import { Box } from '../../../../Common/BoxV2';
import { socialButtons } from '../../model/menus/static-menus';
import styled from 'styled-components';

const Main = styled.div`
  &.socialButtonGroup {
    display: grid;
    grid-auto-flow: column;
    column-gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(40px, max-content));
  }
  &.socialButtonGroup .socialButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    min-width: 40px;
    height: 40px;
    border-radius: 50%;
  }
`;

const IconMapper = {
  facebook: IconBrandsFacebook,
  youtube: IconBrandsLogoYoutube1,
  tiktok: IconBrandsTiktok1,
};

export const SocialButtonGroup = () => {
  return (
    <Main className={'socialButtonGroup'}>
      {socialButtons.map(({ id, url, icon, iconColor }) => {
        const Icon = IconMapper[icon];
        return (
          <Link aria-label={icon} key={id} target="_blank" rel="nofollow" href={url}>
            <Box className={'socialButton'} bg={iconColor}>
              <Icon fontSize={24} color="white100" />
            </Box>
          </Link>
        );
      })}
    </Main>
  );
};
